module.exports = __webpack_public_path__ + "dist/assets/img/D.a025e55e.svg";